import script from "./JobDaysSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./JobDaysSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./JobDaysSkeleton.vue?vue&type=style&index=0&id=8c1426fa&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c1426fa"]])

export default __exports__